import * as S from './ScreenReaderOnly.style';

export { default as ScreenReaderOnly } from './ScreenReaderOnly';
export * from './ScreenReaderOnly.types';
export { S };
